import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  title: {
    display: 'flex',
    alignItems: 'center',
  },

  info: { marginLeft: theme.spacing(1) },
  search: { boxShadow: 'none' },
  label: { fontFamily: 'Source Sans Pro Bold' },
  mainBranchSection: {
    margin: `${theme.spacing(3.6)} 0 ${theme.spacing(4)} ${theme.spacing(3.6)}`,
  },

  mainBranchLabel: {
    display: 'flex',
    alignItems: 'flex-start',
  },

  mainBranchDetail: {
    paddingLeft: theme.spacing(2.1),
    fontSize: '14px',
  },

  mainBranchTitle: {
    fontFamily: 'Source Sans Pro Semibold',
    fontSize: '16px',
    marginBottom: theme.spacing(1),
  },

  accordion: {
    paddingLeft: theme.spacing(0.8),
    backgroundColor: 'inherit',
    flexGrow: 1,
  },

  branch: { paddingLeft: theme.spacing(4.4) },
  branchExpanded: { backgroundColor: theme.palette.common.white },

  branchDetail: {
    fontSize: '14px',
    color: theme.palette.text.secondary,
    padding: `0 0 ${theme.spacing(2)} ${theme.spacing(2.9)}`,
    width: '100%',
  },

  branchLabel: { fontFamily: 'Source Sans Pro Semibold' },
  updateButton: { marginTop: theme.spacing(1) },
  loader: { margin: `auto 0 auto 0` },
})
